import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16 } from '@onefootprint/icons';
import { LinkButton } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { Property } from '../../../store/types';
import { newProperty } from '../../../store/utils';
import { validateChildren } from '../validation';
import { PropertyRow } from './property-row';
type ChildPropertiesEditorProps = {
  properties: Property[];
  onChange: (next: Property[]) => void;
  /** Render "At least one property required" next to the add button. */
  hasNoChildrenError?: boolean;
};

// Per-row errors are computed live (validateChildren on every render) — the
// recursive schema editor can't reuse the top-level saveAttempted gating
// because users can't visually correlate "Save disabled" with which deep row
// is broken.
export const ChildPropertiesEditor = t0 => {
  const $ = _c(41);
  const {
    properties,
    onChange,
    hasNoChildrenError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.task.schema"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  let t2;
  if ($[1] !== onChange || $[2] !== properties) {
    t2 = (index, next) => {
      onChange(properties.map((c, i) => i === index ? next : c));
    };
    $[1] = onChange;
    $[2] = properties;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const update = t2;
  let t3;
  if ($[4] !== onChange || $[5] !== properties) {
    t3 = index_0 => {
      onChange(properties.filter((_, i_0) => i_0 !== index_0));
    };
    $[4] = onChange;
    $[5] = properties;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const remove = t3;
  let t4;
  if ($[7] !== onChange || $[8] !== properties) {
    t4 = () => {
      onChange([...properties, newProperty()]);
    };
    $[7] = onChange;
    $[8] = properties;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const add = t4;
  let t5;
  if ($[10] !== properties) {
    t5 = validateChildren(properties);
    $[10] = properties;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const errors = t5;
  let t6;
  if ($[12] !== t) {
    t6 = t(_temp);
    $[12] = t;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t6) {
    t7 = <span className="text-label-3 text-primary">{t6}</span>;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== errors || $[17] !== properties || $[18] !== remove || $[19] !== update) {
    let t9;
    if ($[21] !== errors || $[22] !== properties.length || $[23] !== remove || $[24] !== update) {
      t9 = (child, i_1) => <PropertyRow key={child.id} property={child} onChange={next_0 => update(i_1, next_0)} onDelete={() => remove(i_1)} canDelete={properties.length > 1} depth={0} errors={errors[child.id]} />;
      $[21] = errors;
      $[22] = properties.length;
      $[23] = remove;
      $[24] = update;
      $[25] = t9;
    } else {
      t9 = $[25];
    }
    t8 = properties.map(t9);
    $[16] = errors;
    $[17] = properties;
    $[18] = remove;
    $[19] = update;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[26] !== t) {
    t9 = t(_temp2);
    $[26] = t;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== add || $[29] !== t9) {
    t10 = <LinkButton variant="caption-3" iconComponent={IcoPlusSmall16} iconPosition="left" onClick={add}>{t9}</LinkButton>;
    $[28] = add;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== hasNoChildrenError || $[32] !== t) {
    t11 = hasNoChildrenError && <span className="text-caption-1 text-error">{t(_temp3)}</span>;
    $[31] = hasNoChildrenError;
    $[32] = t;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t10 || $[35] !== t11) {
    t12 = <div className="flex items-center gap-2 self-start">{t10}{t11}</div>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  let t13;
  if ($[37] !== t12 || $[38] !== t7 || $[39] !== t8) {
    t13 = <div className="flex flex-col gap-2 mt-2">{t7}{t8}{t12}</div>;
    $[37] = t12;
    $[38] = t7;
    $[39] = t8;
    $[40] = t13;
  } else {
    t13 = $[40];
  }
  return t13;
};
function _temp($) {
  return $.label;
}
function _temp2($_0) {
  return $_0.addProperty;
}
function _temp3($_1) {
  return $_1.errors.noChildren;
}